import React from 'react';
import type { QuestionSummary } from '../../../lib/campaign-analytics/summarize';

/** Props for {@link SectionTextList}. */
export interface SectionTextListProps {
  items: QuestionSummary[];
}

/** A section's text questions with their answered counts; values stay with the reports. */
export const SectionTextList: React.FC<SectionTextListProps> = ({ items }) => (
  <ul data-testid="text-list" className="grid grid-cols-1 gap-x-6 px-2 py-1 sm:grid-cols-2">
    {items.map(item => (
      <li key={item.fieldId} className="flex min-w-0 items-baseline justify-between gap-3 py-1 text-sm">
        <span className="min-w-0 truncate text-muted-foreground" data-tip={item.label} data-tip-truncated>{item.label}</span>
        <span className="shrink-0 tabular-nums text-foreground">{`${item.answered} / ${item.eligible}`}</span>
      </li>
    ))}
  </ul>
);
